import { FC } from 'react';
import { getModelIcon } from './helpers';
import { Stack } from '@mui/material';

interface Props {
  modelId: string;
  size?: 'small' | 'medium';
}

const ModelIcon: FC<Props> = ({ modelId, size = 'medium' }) => {
  const IconEl = getModelIcon(modelId);

  if (!IconEl) {
    return;
  }

  const imageWidth = size === 'small' ? 20 : 60;

  return (
    <Stack justifyContent="center" alignItems="center" width={imageWidth} minHeight={imageWidth}>
      <img src={IconEl} alt={modelId} width={imageWidth} />
    </Stack>
  );
};

export default ModelIcon;
